// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixLocation from 'wix-location';

$w.onReady(function () {
	// TODO: write your page related code here...
	let path = wixLocation.path;
	console.log(path[0]);

	if (path[0] === "ueber-mich") {
		$w('#uebermichDot').show();
		$w('#angeboteDot').hide();
		$w('#werkstattDot').hide();
		$w('#agendaDot').hide();
		$w('#kontaktDot').hide();
		console.log("path is " + path[0]);
	}
});